import { render, staticRenderFns } from "./MemoryModule.vue?vue&type=template&id=ed33b352&scoped=true"
import script from "./MemoryModule.vue?vue&type=script&lang=js"
export * from "./MemoryModule.vue?vue&type=script&lang=js"
import style0 from "./MemoryModule.vue?vue&type=style&index=0&id=ed33b352&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed33b352",
  null
  
)

export default component.exports